export { DonutChartComponent } from './donut-chart.component';
export { DonutChartConfig } from './donut-chart-config';
export { DonutChartModule } from './donut-chart.module';
